import { take } from "rxjs";
import { trackingService } from "services/trackingService";
import { AuditEventType } from "types/track/AuditEventType";

export const trackCustomEvent = (event: {
    eventType: AuditEventType;
    otherProperties?: Record<string, any>;
}) => {
    trackingService.trackCustomEvent$({
        eventType: event.eventType,
        otherProperties: event.otherProperties,
    }).pipe(take(1))
    .subscribe({
        error: (err) => console.error(`Tracking event ${event.eventType} failed:`, err)
    });
};